import PropertySelectorHRWO from "@components/inputs/PropertySelectHRWO";
import PageHeader from "@components/PageHeader";
import { useAuth } from "@contexts/AuthContext";
import { Box } from "@mui/material";
import { getRequest } from "@utils/http.service";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

export default function HighRiskWoPage() {
    const {user} = useAuth();

    const [selectedProperties, setSelectedProperties] = useState([]);

    const [metabaseLink, setMetabaseLink] = useState('' as any);

    useEffect(() => {
        if(selectedProperties.length > 0) {
        getMetabaseLink();
        } else {
            setMetabaseLink(user?.metabaseLink);
        }
    }, [selectedProperties]);

    const getMetabaseLink = async () => {
        const propertyIds = selectedProperties.join(',');
        const metabaseLinkResp = await getRequest(`auth/metabase-link?propertyIds=${propertyIds}`, {
            headers: {
                Authorization: `Bearer ${user!!.token}`
            }
        });
        setMetabaseLink(metabaseLinkResp?.data?.metabaseLink || '');
    }

    return <>
        <PageHeader
            title={<FormattedMessage id='Growth and Water Intrusion Work Orders' />}
            selection={(user?.properties?.length || 0) > 1 && <PropertySelectorHRWO selectedProperties={selectedProperties} setSelectedProperties={setSelectedProperties}/>}
        />
        <Box sx={{height: 'calc(100vh - 80px)'}}>
            <iframe style={{border: 0}} src={metabaseLink ?? user?.metabaseLink} width={'100%'} height={'100%'}></iframe>
        </Box>
    </>
}